module.exports = __webpack_public_path__ + "static/media/logoINE_blanco.f7d2216a.svg";